import { Item } from '@/interfaces/cash-register/Item'
import { PaymentType } from '@invo.space/shared'
import API from '@/lib/api'

export interface SuccessCreateReceiptResponse {
  status: 'ok'
  id: string
  uuid: string
  permalink: string
  qr?: string
}

export async function createReceipt(
  paymentType: PaymentType,
  receiptLines: Item[],
  warehouseId?: string | null,
): Promise<SuccessCreateReceiptResponse> {
  return API.post('/api/v2/receipts', {
    paymentType,
    warehouseId: warehouseId ?? undefined,
    receiptLines: receiptLines.map((line) => ({
      ...line,
      unitPrice: {
        amount: (line.unitPrice * 100).toString(),
        currency: 'CZK',
      },
      productName: undefined,
      skuName: undefined,
      description: line.description || undefined,
    })),
  })
    .then((res) => res.data)
    .then((data) => data as SuccessCreateReceiptResponse)
}

export async function updateReceiptPaymentType(
  id: string,
  paymentType: PaymentType,
): Promise<SuccessCreateReceiptResponse> {
  return API.patch(`/api/v2/receipts/${id}`, { paymentType }).then((res) => res.data as SuccessCreateReceiptResponse)
}
